const NAMESPACE = "addressSubElement";

const KEYS = {
    streetLabel: "streetLabel",
    cityLabel: "cityLabel",
    provinceLabel: "provinceLabel",
    stateLabel: "stateLabel",
    countyLabel: "countyLabel",
    postalCodeLabel: "postalCodeLabel",
    zipCodeLabel: "zipCodeLabel",
    requiredFieldsMessage: "requiredFieldsMessage",
    zipCodeLengthValidationMessage: "zipCodeLengthValidationMessage",
    postalCodeLengthValidationMessage: "postalCodeLengthValidationMessage",
    zipCodeDigitsMessage: "zipCodeDigitsMessage",
    postalCodeDigitsMessage: "postalCodeDigitsMessage"
};

const MESSAGES = {
    [KEYS.streetLabel]: {
        value: "Street",
        comment: "Label for street address field"
    },
    [KEYS.cityLabel]: {
        value: "City",
        comment: "Label for city field"
    },
    [KEYS.provinceLabel]: {
        value: "Province",
        comment: "Label for province field"
    },
    [KEYS.stateLabel]: {
        value: "State",
        comment: "Label for state field"
    },
    [KEYS.countyLabel]: {
        value: "County",
        comment: "Label for county field"
    },
    [KEYS.postalCodeLabel]: {
        value: "Postal Code",
        comment: "Label for postal code field"
    },
    [KEYS.zipCodeLabel]: {
        value: "Zip Code",
        comment: "Label for zip code field"
    },
    [KEYS.requiredFieldsMessage]: {
        value: "These fields are required: {requiredFields}",
        comment: "Message for required fields"
    },
    [KEYS.zipCodeLengthValidationMessage]: {
        value: "Please enter exactly 5 digits for Zip Code.",
        comment: "Message for zip code length validation"
    },
    [KEYS.postalCodeLengthValidationMessage]: {
        value: "Please enter 3-7 characters for Postal Code.",
        comment: "Message for postal code length validation"
    },
    [KEYS.zipCodeDigitsMessage]: {
        value: "Please enter only digits for Zip Code.",
        comment: "Message for zip code digits validation"
    },
    [KEYS.postalCodeDigitsMessage]: {
        value: "Please enter only alphanumeric characters for Postal Code.",
        comment: "Message for postal code digits validation"
    }
};

export { KEYS, NAMESPACE, MESSAGES };
